import { AccountHeaderType } from "pages/Setup/Account/LinkAccount/types";

export const dataAccountLinkSales: AccountHeaderType[] = [
    {
        Header: "SALES LINKED ACCOUNT",
        LinkAccount: [
            {
                linked_account_id: 1,
                linked_account_code: "LA04",
                linked_account_name: "Sales Linked Account",
                description: "Asset Account for Tracking AR",
                account_coa: "1"
            },
            {
                linked_account_id: 2,
                linked_account_code: "LA05",
                linked_account_name: "Sales Linked Account",
                description: "Asset Bank Account for Customer Receivable",
                account_coa: "1"
            },
            {
                linked_account_id: 3,
                linked_account_code: "LA06",
                linked_account_name: "Sales Linked Account",
                description: "Liability Account for Customer Deposit",
                account_coa: "2"
            },
            {
                linked_account_id: 7,
                linked_account_code: "LA12",
                linked_account_name: "Sales Linked Account",
                description: "Liability Account for Returns",
                account_coa: "2"
            },
            {
                linked_account_id: 4,
                linked_account_code: "TAXC",
                linked_account_name: "Sales Linked Account",
                description: "Liability Tax Collected",
                account_coa: "2"
            },
            {
                linked_account_id: 5,
                linked_account_code: "SA01",
                linked_account_name: "Sales Linked Account",
                description: "Income Account For Freight On Sale",
                account_coa: "4"
            },
            {
                linked_account_id: 6,
                linked_account_code: "TRC",
                linked_account_name: "Sales Linked Account",
                description: "Liability Sales Tax Allocation",
                account_coa: "2"
            },
        ]
    }
]